var _Rect, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgJockey(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#E1087E",
    d: "M16 17c.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0019.5 13.5c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0016 10c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0012.5 13.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0016 17zm0 6.9a7.206 7.206 0 002.613-1.487 11.848 11.848 0 001.987-2.288 10.356 10.356 0 00-2.238-.837A9.803 9.803 0 0016 19c-.8 0-1.588.096-2.363.288-.774.191-1.52.47-2.237.837.567.85 1.23 1.613 1.987 2.288A7.206 7.206 0 0016 23.9zm0 2a1.976 1.976 0 01-.625-.1c-2.25-.75-4.042-2.137-5.375-4.163-1.333-2.024-2-4.204-2-6.537v-4.725c0-.417.12-.792.363-1.125.241-.333.554-.575.937-.725l6-2.25a2.07 2.07 0 01.7-.125c.233 0 .467.042.7.125l6 2.25c.383.15.696.392.938.725.241.333.362.708.362 1.125V15.1c0 2.333-.667 4.513-2 6.537-1.333 2.026-3.125 3.413-5.375 4.163a1.976 1.976 0 01-.625.1z"
  })));
}
export default SvgJockey;